// extracted by extract-css-chunks-webpack-plugin
module.exports = {"mod-checked":"styles__mod-checked--jfjkw","modChecked":"styles__mod-checked--jfjkw"};